import { createAsyncThunk } from "@reduxjs/toolkit";

/**
 * Legacy thunk for revenue charts (no longer used by main dashboard; dashboard uses /dashboard/* API).
 * Kept for reducer compatibility; returns empty data.
 */
export const getRevenueChartsData = createAsyncThunk(
  "dashboardEcommerce/getRevenueChartsData",
  async () => {
    return [];
  }
);
